import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import { checkRequired } from "pages/formTools";
import { Vendor } from "../..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

// The business address is held on the account, so it arrives alongside the
// vendor fields rather than on them.
export const validateBusinessInfo = (
  data: Vendor & { address: string },
): FieldErrorMap => ({
  businessName: checkRequired(ta("fields.business_name"), data.businessName),

  operatingAs: data.operatingAsSameAsLegal
    ? null
    : checkRequired(ta("fields.operating_as"), data.operatingAs ?? ""),

  address: checkRequired(ta("fields.business_address"), data.address),

  mailingAddress: data.mailingSameAsBusiness
    ? null
    : checkRequired(ta("fields.mailing_address"), data.mailingAddress ?? ""),
});
